import { useState, useEffect } from "react";
import {
  fetchGroupList, fetchCodeList,
  createGroup, updateGroup, deleteGroup,
  createCode, updateCode, deleteCode
} from "../api/codeApi";
import Toast from "../components/Toast";

const detailStyles = {
  grid  : { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 },
  field : { display: "flex", flexDirection: "row", alignItems: "center", gap: 0, background: "#fafafa", borderRadius: 8, border: "1.5px solid #e0e0e0", overflow: "hidden" },
  label : { fontSize: 13, fontWeight: 600, color: "#666", background: "#f0f4ff", padding: "10px 14px", minWidth: 100, whiteSpace: "nowrap", borderRight: "1.5px solid #e0e0e0" },
  input : { border: "none", borderRadius: 0, padding: "10px 12px", fontSize: 14, outline: "none", background: "transparent", color: "#1a1a2e", width: "100%", boxSizing: "border-box" },
};

export default function CodePage() {
  const [groupList,    setGroupList]    = useState([]);
  const [codeList,     setCodeList]     = useState([]);
  const [selGroup,     setSelGroup]     = useState(null);
  const [toast,        setToast]        = useState('');
  const [showGroupForm, setShowGroupForm] = useState(false);
  const [showCodeForm,  setShowCodeForm]  = useState(false);
  const [editGroup,    setEditGroup]    = useState(null);
  const [editCode,     setEditCode]     = useState(null);
  const [groupForm,    setGroupForm]    = useState({ group_cd: '', group_nm: '', description: '', use_yn: 'Y' });
  const [codeForm,     setCodeForm]     = useState({ code: '', code_nm: '', sort_no: 0, use_yn: 'Y', etc1: '', etc2: '' });

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(''), 2500); };

  const loadGroups = async () => {
    const res = await fetchGroupList();
    if (res.success) setGroupList(res.data);
  };

  const loadCodes = async (group_cd) => {
    const res = await fetchCodeList(group_cd);
    if (res.success) setCodeList(res.data);
  };

  useEffect(() => { loadGroups(); }, []);

  const handleGroupClick = (group) => {
    setSelGroup(group);
    loadCodes(group.group_cd);
  };

  // 그룹 저장
  const handleGroupSave = async () => {
    if (!groupForm.group_cd || !groupForm.group_nm) {
      alert("그룹코드와 그룹명은 필수입니다."); return;
    }
    const res = editGroup
      ? await updateGroup(editGroup.group_cd, groupForm)
      : await createGroup(groupForm);
    if (res.success) {
      setShowGroupForm(false); setEditGroup(null);
      setGroupForm({ group_cd: '', group_nm: '', description: '', use_yn: 'Y' });
      loadGroups();
      showToast(editGroup ? '✅ 수정되었습니다.' : '✅ 등록되었습니다.');
    } else showToast(`❌ ${res.message}`);
  };

  // 그룹 삭제
  const handleGroupDelete = async (group) => {
    if (!window.confirm(`"${group.group_nm}" 그룹과 하위 코드를 모두 삭제하시겠습니까?`)) return;
    const res = await deleteGroup(group.group_cd);
    if (res.success) {
      if (selGroup?.group_cd === group.group_cd) { setSelGroup(null); setCodeList([]); }
      loadGroups();
      showToast('✅ 삭제되었습니다.');
    } else showToast(`❌ ${res.message}`);
  };

  // 코드 저장
  const handleCodeSave = async () => {
    if (!codeForm.code || !codeForm.code_nm) {
      alert("코드와 코드명은 필수입니다."); return;
    }
    const res = editCode
      ? await updateCode(selGroup.group_cd, editCode.code, codeForm)
      : await createCode(selGroup.group_cd, codeForm);
    if (res.success) {
      setShowCodeForm(false); setEditCode(null);
      setCodeForm({ code: '', code_nm: '', sort_no: 0, use_yn: 'Y', etc1: '', etc2: '' });
      loadCodes(selGroup.group_cd);
      showToast(editCode ? '✅ 수정되었습니다.' : '✅ 등록되었습니다.');
    } else showToast(`❌ ${res.message}`);
  };

  // 코드 삭제
  const handleCodeDelete = async (code) => {
    if (!window.confirm(`"${code.code_nm}" 코드를 삭제하시겠습니까?`)) return;
    const res = await deleteCode(selGroup.group_cd, code.code);
    if (res.success) { loadCodes(selGroup.group_cd); showToast('✅ 삭제되었습니다.'); }
    else showToast(`❌ ${res.message}`);
  };

  return (
    <div style={styles.wrap}>
      <Toast msg={toast} />

      <div style={styles.pageHeader}>
        <h1 style={styles.pageTitle}>⚙️ 공통코드 관리</h1>
      </div>

      <div style={styles.layout}>
        {/* 좌측 - 그룹 목록 */}
        <div style={styles.leftPanel}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
            <span style={{ fontSize: 14, fontWeight: 700, color: "#1a1a2e" }}>코드 그룹</span>
            <button style={styles.smAddBtn} onClick={() => {
              setEditGroup(null);
              setGroupForm({ group_cd: '', group_nm: '', description: '', use_yn: 'Y' });
              setShowGroupForm(true);
            }}>＋ 추가</button>
          </div>
          <div style={styles.card}>
            {groupList.length === 0 ? (
              <div style={styles.empty}>그룹이 없습니다.</div>
            ) : groupList.map((g, i) => (
              <div key={i}
                style={{ ...styles.groupItem, background: selGroup?.group_cd === g.group_cd ? "#e8f4fd" : "#fff" }}
                onClick={() => handleGroupClick(g)}>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 700, color: "#1a1a2e" }}>{g.group_nm}</div>
                  <div style={{ fontSize: 11, color: "#aaa" }}>{g.group_cd}</div>
                </div>
                <div style={{ display: "flex", gap: 4 }} onClick={e => e.stopPropagation()}>
                  <button style={styles.smEditBtn} onClick={() => {
                    setEditGroup(g);
                    setGroupForm({ group_cd: g.group_cd, group_nm: g.group_nm, description: g.description || '', use_yn: g.use_yn });
                    setShowGroupForm(true);
                  }}>수정</button>
                  <button style={styles.smDelBtn} onClick={() => handleGroupDelete(g)}>삭제</button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 우측 - 코드 목록 */}
        <div style={styles.rightPanel}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
            <span style={{ fontSize: 14, fontWeight: 700, color: "#1a1a2e" }}>
              {selGroup ? `${selGroup.group_nm} 코드 목록` : '그룹을 선택하세요'}
            </span>
            {selGroup && (
              <button style={styles.smAddBtn} onClick={() => {
                setEditCode(null);
                setCodeForm({ code: '', code_nm: '', sort_no: codeList.length + 1, use_yn: 'Y', etc1: '', etc2: '' });
                setShowCodeForm(true);
              }}>＋ 추가</button>
            )}
          </div>

          {!selGroup ? (
            <div style={{ ...styles.card, ...styles.empty }}>좌측에서 그룹을 선택하세요.</div>
          ) : (
            <div style={styles.card}>
              {/* 헤더 */}
              <div style={{ display: "grid", gridTemplateColumns: "0.8fr 1fr 2fr 0.6fr 0.6fr 0.6fr 1fr", padding: "10px 16px", background: "#f8faff", borderBottom: "1px solid #e8f0fe" }}>
                {["코드", "코드명", "여분1", "여분2", "정렬", "사용", ""].map(h => (
                  <div key={h} style={{ fontSize: 12, fontWeight: 700, color: "#888" }}>{h}</div>
                ))}
              </div>
              {codeList.length === 0 ? (
                <div style={styles.empty}>등록된 코드가 없습니다.</div>
              ) : codeList.map((c, i) => (
                <div key={i} style={{ display: "grid", gridTemplateColumns: "0.8fr 1fr 2fr 0.6fr 0.6fr 0.6fr 1fr", padding: "12px 16px", borderBottom: "1px solid #f5f5f5", alignItems: "center" }}>
                  <div style={{ fontSize: 13, color: "#1677ff", fontWeight: 600 }}>{c.code}</div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: "#1a1a2e" }}>{c.code_nm}</div>
                  <div style={{ fontSize: 12, color: "#888" }}>{c.etc1 || '-'}</div>
                  <div style={{ fontSize: 12, color: "#888" }}>{c.etc2 || '-'}</div>
                  <div style={{ fontSize: 12, color: "#888" }}>{c.sort_no}</div>
                  <div style={{ fontSize: 12 }}>
                    <span style={{ color: c.use_yn === 'Y' ? "#52c41a" : "#ff4d4f", fontWeight: 600 }}>
                      {c.use_yn === 'Y' ? '사용' : '미사용'}
                    </span>
                  </div>
                  <div style={{ display: "flex", gap: 4 }}>
                    <button style={styles.smEditBtn} onClick={() => {
                      setEditCode(c);
                      setCodeForm({ code: c.code, code_nm: c.code_nm, sort_no: c.sort_no, use_yn: c.use_yn, etc1: c.etc1 || '', etc2: c.etc2 || '' });
                      setShowCodeForm(true);
                    }}>수정</button>
                    <button style={styles.smDelBtn} onClick={() => handleCodeDelete(c)}>삭제</button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* 그룹 등록/수정 모달 */}
      {showGroupForm && (
        <div style={ms.overlay}>
          <div style={ms.modal}>
            <div style={ms.header}>
              <span style={ms.title}>{editGroup ? '✏️ 그룹 수정' : '➕ 그룹 등록'}</span>
              <button style={ms.closeBtn} onClick={() => setShowGroupForm(false)}>✕</button>
            </div>
            <div style={ms.body}>
              <div style={detailStyles.field}>
                <label style={detailStyles.label}>그룹코드 *</label>
                <input style={{ ...detailStyles.input, background: editGroup ? "#f5f5f5" : "transparent", color: editGroup ? "#aaa" : "#1a1a2e" }}
                  value={groupForm.group_cd}
                  onChange={e => setGroupForm(p => ({ ...p, group_cd: e.target.value }))}
                  disabled={!!editGroup} placeholder="예) ATT_TYPE" />
              </div>
              <div style={detailStyles.field}>
                <label style={detailStyles.label}>그룹명 *</label>
                <input style={detailStyles.input} value={groupForm.group_nm}
                  onChange={e => setGroupForm(p => ({ ...p, group_nm: e.target.value }))}
                  placeholder="그룹명 입력" />
              </div>
              <div style={detailStyles.field}>
                <label style={detailStyles.label}>설명</label>
                <input style={detailStyles.input} value={groupForm.description}
                  onChange={e => setGroupForm(p => ({ ...p, description: e.target.value }))}
                  placeholder="설명 입력" />
              </div>
              <div style={detailStyles.field}>
                <label style={detailStyles.label}>사용여부</label>
                <select style={detailStyles.input} value={groupForm.use_yn}
                  onChange={e => setGroupForm(p => ({ ...p, use_yn: e.target.value }))}>
                  <option value="Y">사용</option>
                  <option value="N">미사용</option>
                </select>
              </div>
            </div>
            <div style={ms.footer}>
              <button style={ms.cancelBtn} onClick={() => setShowGroupForm(false)}>취소</button>
              <button style={ms.saveBtn} onClick={handleGroupSave}>{editGroup ? '저장' : '등록'}</button>
            </div>
          </div>
        </div>
      )}

      {/* 코드 등록/수정 모달 */}
      {showCodeForm && (
        <div style={ms.overlay}>
          <div style={ms.modal}>
            <div style={ms.header}>
              <span style={ms.title}>{editCode ? '✏️ 코드 수정' : '➕ 코드 등록'}</span>
              <button style={ms.closeBtn} onClick={() => setShowCodeForm(false)}>✕</button>
            </div>
            <div style={ms.body}>
              <div style={detailStyles.field}>
                <label style={detailStyles.label}>코드 *</label>
                <input style={{ ...detailStyles.input, background: editCode ? "#f5f5f5" : "transparent", color: editCode ? "#aaa" : "#1a1a2e" }}
                  value={codeForm.code}
                  onChange={e => setCodeForm(p => ({ ...p, code: e.target.value }))}
                  disabled={!!editCode} placeholder="코드값 입력" />
              </div>
              <div style={detailStyles.field}>
                <label style={detailStyles.label}>코드명 *</label>
                <input style={detailStyles.input} value={codeForm.code_nm}
                  onChange={e => setCodeForm(p => ({ ...p, code_nm: e.target.value }))}
                  placeholder="코드명 입력" />
              </div>
              <div style={detailStyles.field}>
                <label style={detailStyles.label}>정렬순서</label>
                <input style={detailStyles.input} type="number" value={codeForm.sort_no}
                  onChange={e => setCodeForm(p => ({ ...p, sort_no: Number(e.target.value) }))} />
              </div>
              <div style={detailStyles.field}>
                <label style={detailStyles.label}>사용여부</label>
                <select style={detailStyles.input} value={codeForm.use_yn}
                  onChange={e => setCodeForm(p => ({ ...p, use_yn: e.target.value }))}>
                  <option value="Y">사용</option>
                  <option value="N">미사용</option>
                </select>
              </div>
              <div style={detailStyles.field}>
                <label style={detailStyles.label}>여분1</label>
                <input style={detailStyles.input} value={codeForm.etc1}
                  onChange={e => setCodeForm(p => ({ ...p, etc1: e.target.value }))}
                  placeholder="여분 값 (선택)" />
              </div>
              <div style={detailStyles.field}>
                <label style={detailStyles.label}>여분2</label>
                <input style={detailStyles.input} value={codeForm.etc2}
                  onChange={e => setCodeForm(p => ({ ...p, etc2: e.target.value }))}
                  placeholder="여분 값 (선택)" />
              </div>
            </div>
            <div style={ms.footer}>
              <button style={ms.cancelBtn} onClick={() => setShowCodeForm(false)}>취소</button>
              <button style={ms.saveBtn} onClick={handleCodeSave}>{editCode ? '저장' : '등록'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  wrap       : { background: "#f5f7fa", padding: 24, fontFamily: "'Noto Sans KR', sans-serif" },
  pageHeader : { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 },
  pageTitle  : { fontSize: 22, fontWeight: 800, color: "#1a1a2e", margin: 0 },
  layout     : { display: "grid", gridTemplateColumns: "280px 1fr", gap: 16 },
  leftPanel  : { display: "flex", flexDirection: "column" },
  rightPanel : { display: "flex", flexDirection: "column" },
  card       : { background: "#fff", borderRadius: 12, boxShadow: "0 2px 8px rgba(0,0,0,0.06)", overflow: "hidden" },
  groupItem  : { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 16px", borderBottom: "1px solid #f5f5f5", cursor: "pointer", transition: "background 0.15s" },
  empty      : { textAlign: "center", padding: "40px 0", color: "#bbb", fontSize: 14 },
  smAddBtn   : { background: "linear-gradient(135deg, #1677ff, #4096ff)", color: "#fff", border: "none", borderRadius: 6, padding: "6px 12px", fontSize: 12, fontWeight: 600, cursor: "pointer" },
  smEditBtn  : { background: "#fff", border: "1px solid #1677ff", color: "#1677ff", borderRadius: 5, padding: "3px 8px", fontSize: 11, cursor: "pointer" },
  smDelBtn   : { background: "#fff2f0", border: "1px solid #ffccc7", color: "#ff4d4f", borderRadius: 5, padding: "3px 8px", fontSize: 11, cursor: "pointer" },
};

const ms = {
  overlay  : { position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 100, display: "flex", alignItems: "center", justifyContent: "center" },
  modal    : { background: "#fff", borderRadius: 16, width: "100%", maxWidth: 460, margin: "0 16px", boxShadow: "0 20px 60px rgba(0,0,0,0.3)", overflow: "hidden" },
  header   : { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "20px 24px", borderBottom: "1px solid #f0f0f0" },
  title    : { fontSize: 16, fontWeight: 700, color: "#1a1a2e" },
  closeBtn : { background: "none", border: "none", fontSize: 18, color: "#aaa", cursor: "pointer" },
  body     : { padding: "20px 24px", display: "flex", flexDirection: "column", gap: 12 },
  footer   : { display: "flex", gap: 10, justifyContent: "flex-end", padding: "16px 24px", borderTop: "1px solid #f0f0f0" },
  cancelBtn: { background: "#fff", border: "1px solid #e0e0e0", borderRadius: 8, padding: "10px 20px", fontSize: 14, color: "#666", cursor: "pointer" },
  saveBtn  : { background: "linear-gradient(135deg, #1677ff, #4096ff)", border: "none", borderRadius: 8, padding: "10px 20px", fontSize: 14, color: "#fff", fontWeight: 700, cursor: "pointer" },
};